import { createContext, useContext, useMemo } from 'react';
import type React from 'react';
import type { PropsWithChildren } from 'react';

import { useSearchUsersByModel } from './useSearchUsersBy';
import type { UserRecord } from '@vlabs/api/artemy/model';

interface SearchUsersByContextValue {
  data?: UserRecord[];
  setValue: (value: string) => void;
  value: string;
}

const SearchUsersByContext = createContext<SearchUsersByContextValue | undefined>(undefined);

function SearchUsersByProvider({
  children,
}: PropsWithChildren): React.JSX.Element {
  const {
    data,
    setValue,
    value,
  } = useSearchUsersByModel();

  const contextValue = useMemo(() => ({
    data,
    setValue,
    value,
  }), [data, setValue, value]);

  return (
    <SearchUsersByContext.Provider value={contextValue}>
      {children}
    </SearchUsersByContext.Provider>
  );
}

function useSearchUsersBy(): SearchUsersByContextValue | undefined {
  return useContext(SearchUsersByContext);
}

export { SearchUsersByProvider, useSearchUsersBy };
